export default defineNuxtRouteMiddleware( ( to ) => {
	// if ( to.path === "/password" ) return;
	// const authenticated = useCookie( "site_authenticated" );
	// if ( !authenticated.value ) {
	// 	return navigateTo( "/password" );
	// }
} );